import React from 'react';

import './index.scss';

const PromotionalRateInfoBox = () => {
  return (
    <div className="promotional-rate">
      <div className="promotional-rate__icon-wrapper">
        <div className="promotional-rate__icon"></div>
      </div>
      <div className="promotional-rate__title">
        <h4>A promotional rate has been applied!</h4>
      </div>
      <div className="promotional-rate__content">
        For applications submitted between 23 April 2024 and 21 May 2024, enjoy an interest rate
        reduction of up to 3%. T&C apply.
      </div>
    </div>
  );
};

export default PromotionalRateInfoBox;
